<template>
  <form>
    <md-card data-tour="advanced_sfu_config">
      <md-card-header
        class="md-card-header-icon"
        :class="getClass(headerColor)"
      >
        <div class="card-icon">
          <md-icon>call_split</md-icon>
        </div>
        <h4 class="title">
          SFU Configuration
        </h4>
        <help-link :link="helpLink.link" title="sfu"></help-link>
      </md-card-header>
      <md-card-content>
        <div class="md-layout">
          <div class="md-layout-item md-size-50 md-small-size-100">
            <md-field>
              <label>Audio Input Max Bitrate (kbps)</label>
              <md-input
                v-model="channel.sfu.audioInput.maxBitrate"
                v-on:blur="validateSFU($v.channel.sfu.audioInput.maxBitrate)"
                type="number"
                class="full-width"
                data-tour="channel_sfu_audio_bitrate"
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-size-50 md-small-size-100">
            <md-field>
              <label>Video Input Max Bitrate (kbps)</label>
              <md-input
                v-model="channel.sfu.videoInput.maxBitrate"
                v-on:blur="validateSFU($v.channel.sfu.videoInput.maxBitrate)"
                type="number"
                class="full-width"
                data-tour="channel_sfu_video_bitrate"
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout md-alignment-center-left">
            <md-switch
              v-model="simulcastEnabled"
              class="md-layout-item md-size-5"
              :disabled="!simulcastAuthorized"
            ></md-switch>
            <div class="md-layout-item">
              Enable Simulcast
            </div>
          </div>
        </div>
      </md-card-content>
    </md-card>
  </form>
</template>
<script>
import validationRules from '../../validationRules';
import { HelpLinkTemplate } from "@/fmComponents";
import helpLinks from '../../contextualHelpLinks.js';

export default {
  props: {
    channel: null,
    ogChannel: null,
    headerColor: {
      type: String,
      default: ""
    },
    simulcastAuthorized: {
      type: Boolean,
      default: false
    },
  },
  components: {
    'help-link': HelpLinkTemplate
  },
  data: () => ({
    helpLink: helpLinks.channelConfig.SFUConfiguration
  }),
  validations () {
    return validationRules;
  },
  computed: {
    simulcastEnabled: {
      get: function() {
        if (
          this.channel == null ||
          this.channel.sfu.videoOutput == null ||
          this.channel.sfu.videoOutput.simulcast == null
        ) {
          return false;
        }
        return this.channel.sfu.videoOutput.simulcast.enabled;
      },
      set: function(state) {
        this.channel.sfu.videoOutput.simulcast.enabled = state;
      }
    },
    validationError: function () {
      return this.$v.channel.sfu.$anyError;
    }
  },
  methods: {
    getClass: function(headerColor) {
      return "md-card-header-" + headerColor + "";
    },
    validateSFU: function(input){
      input.$touch();
      if (input.$error){
        if (this.$v.channel.sfu.audioInput.maxBitrate.$error){
          this.$store.commit("pushError", "Supported SFU Audio Input Max Bitrate is between 1kbps and 200kbps.");
        }
        if (this.$v.channel.sfu.videoInput.maxBitrate.$error){
          this.$store.commit("pushError", "Supported SFU Video Input Max Bitrate is between 1kbps and 20,000kbps.");
        }
      }
    }
  },
  watch: {
    validationError(val) {
      this.$emit("validationErrorChanged", this, val);
    }
  }
};
</script>
<style lang="scss" scoped>
/deep/ h5.h5-sc {
  margin-top: 20px;
  margin-bottom: 0;
}
@media screen and (min-width: 1117px) {
  h4.title{
    display: inline-flex;
  }
  .contextual-help {
    display: inline-flex;
    float: right;
    margin-top: 21px;
  }
  /deep/ .contextual-help > a {
    padding-top: 2px;
  }
}
</style>
